export default "__VITE_ASSET__ac12591d__"